import React from 'react'

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles'

import { Omit } from 'types'
import { IContestEntry } from 'protos'

import Avatar from '@material-ui/core/Avatar'
import ButtonBase, { ButtonBaseProps } from '@material-ui/core/ButtonBase'

import Badge from 'components/Badge'
import RankBadge from 'components/RankBadge'

import avatarPlaceholder from './assets/avatar_placeholder.png'

interface Props extends Omit<ButtonBaseProps, 'onClick'> {
  user?: IContestEntry['user']
  rank?: IContestEntry['rank']
  onClick?: (userId: string) => void
}

const styles = createStyles({
  root: {
    borderRadius: '50%',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const EventRankingItemAvatar: React.SFC<InjectedProps> = ({ user, rank, onClick, classes }) => {
  const isDisabled = !(onClick && user && user.userId)
  const isShowRank = rank && rank >= 1 && rank <= 3

  const _onClick = !isDisabled ? (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick!(user!.userId!)
  } : undefined

  const _onMouseDown = !isDisabled ? (e: React.MouseEvent) => {
    e.preventDefault()
  } : undefined

  return (
    <ButtonBase disabled={isDisabled} className={classes.root} onClick={_onClick} onMouseDown={_onMouseDown}>
      {isShowRank && (
        <Badge badgeContent={<RankBadge rank={rank} size="small" />}>
          <Avatar src={(user && user.photoUrl) || avatarPlaceholder} />
        </Badge>
      )}
      {!isShowRank && (
        <Avatar src={(user && user.photoUrl) || avatarPlaceholder} />
      )}
    </ButtonBase>
  )
}

export default withStyles(styles)(EventRankingItemAvatar)
